import { create } from 'apisauce';
import _ from 'lodash';
import { storage } from 'utils';

/*

PROD:
REACT_APP_API_URL=https://api.massphoning.tel
REACT_APP_CLIENT_ID=2_4ilm9i762osg0owcg0g4wkokkk888cs4ookco88gscgk4k880o
REACT_APP_CLIENT_SECRET=6dj3taad2z4s8ko008w0c44gowkksgkkkkg8ok0k4c0g0s4c0o

DEV:
REACT_APP_API_URL=https://mp-api.epicmonday.io
REACT_APP_CLIENT_ID=1_5usoilwxno084808so04o40wos8g48ww4g44kcc8gwgosww08k
REACT_APP_CLIENT_SECRET=5ivy5ne6aeg4c0s4s8ggowgg0w8g04k4w88s804go4k0cos048

*/

const api = create( {
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
} );

api.addRequestTransform( ( request ) => {
  const accessToken = storage.get( 'massphoning:token' );
  if ( accessToken ) request.headers.Authorization = `Bearer ${accessToken}`;
} );

api.addResponseTransform( ( response ) => {
  const { data, ok } = response;

  if ( !ok ) {
    let errors = '';

    if (
      response
      && response.status === 401
      && data
      && ( data.error === 'invalid_grant' || data.error === 'access_denied' )
    ) {
      storage.clear( 'massphoning:token' );
      storage.clear( 'persist:massphoning' );
      return window.location.replace( '/auth/login' );
    }

    if ( data ) {
      if ( data.form ) {
        errors = {};
        _.map( data.form.errors, ( error, key ) => {
          if ( !_.isEmpty( error ) ) {
            errors[key] = error.join( '\n' );
          }
        } );
      } else if ( data.errors ) {
        if ( _.isObject( data.errors ) && !_.isArray( data.errors ) ) {
          errors = [];
          _.map( data.errors, ( error ) => {
            if ( _.isString( error ) ) errors.push( error );
            else if ( _.isArray( errors ) ) errors.push( error.join( '\n' ) );
          } );
          errors = errors.join( '\n' );
        } else if ( _.isArray( data.errors ) ) {
          errors = data.errors.join( '\n' );
        } else {
          errors = data.errors;
        }
      } else if ( data.message ) errors = data.message;
      else if ( data.error_description ) errors = data.error_description;
      else errors = data;
    }

    if ( !errors || _.isEmpty( errors ) ) errors = 'apiError';
    if ( response.config.method === 'get' && !_.isString( errors ) ) {
      response.errors = 'apiError';
    } else response.errors = errors;
  }
} );

export default api;
